const Typography = (props) => {
    let { tag, type, className, children, ...remainingProps } = props

    const typographyClassName = 'typography--' + type
    className = className ?
        className + ' ' + typographyClassName :
        typographyClassName

    const Tag = tag;
    return (<Tag className={className} {...remainingProps}>{children}</Tag>)
}

export const H1 = (props) => <Typography tag="h1" type="h1" {...props} />
export const H2 = (props) => <Typography tag="h2" type="h2" {...props} />
export const H3 = (props) => <Typography tag="h3" type="h3" {...props} />
export const H4 = (props) => <Typography tag="h4" type="h4" {...props} />
export const H5 = (props) => <Typography tag="h5" type="h5" {...props} />
export const H6 = (props) => <Typography tag="h6" type="h6" {...props} />
export const Subtitle1 = (props) => <Typography tag="h2" type="subtitle1" {...props} />
export const Subtitle2 = (props) => <Typography tag="h3" type="subtitle2" {...props} />
export const Body1 = (props) => <Typography tag="p" type="body1" {...props} />
export const Body2 = (props) => <Typography tag="p" type="body2" {...props} />
export const Caption = (props) => <Typography tag="span" type="caption" {...props} />
export const ButtonText = (props) => <Typography tag="span" type="button" {...props} />
export const Overline = (props) => <Typography tag="span" type="overline" {...props} />

